import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ChipsAutocompleteComponent } from './chips-autocomplete-type.component';
import { MaterialModule } from '@lockton-apps/material';
import { FormFieldModule } from '@lockton-apps/shared/ui/lui';
import { MatchingLabelPipe } from '../pipes/matching-label/matching-label.pipe';
import { CastObservablePipe, FilterWithPipe } from '@lockton-apps/shared/ui/pipes';
import {
  FormlySelectModule,
  FormlySelectOptionsPipe,
} from '@ngx-formly/core/select';

@NgModule({
  declarations: [ChipsAutocompleteComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'chips-autocomplete',
          component: ChipsAutocompleteComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    FormFieldModule,
    MatchingLabelPipe,
    FilterWithPipe,
    FormlySelectModule,
    CastObservablePipe
  ],
  providers: [FormlySelectOptionsPipe],
})
export class ChipsAutocompleteTypeModule {}
